const TOLOKA_ORIGIN_REGEXP = /^https:\/\/([^.]+\.){1,5}(toloka-test|toloka)\.ai(:9001)*\/?$/;
const TOLOKA_PULSAR_ORIGIN_REGEXP = /^https:\/\/([^.]+\.){0,5}tolokamodels\.tech\/?$/;

const isTolokaOrigin = (origin: string) => {
    if (TOLOKA_ORIGIN_REGEXP.test(origin)) {
        return true;
    }

    if (TOLOKA_PULSAR_ORIGIN_REGEXP.test(origin)) {
        return true;
    }

    const noPort = origin.replace(/:\d+$/, '');

    if (noPort.endsWith('iframe-toloka.com')) {
        return true;
    }

    return false;
};

const isTbOrigin = (origin: string) => {
    const noPort = origin.replace(/:\d+$/, '');

    if (noPort.endsWith('tb.toloka.dev')) {
        return true;
    }

    return false;
};

const isVsCodeOrigin = (origin: string) => {
    if (origin.startsWith('vscode-webview://')) {
        return true;
    }

    return false;
};

const isDevOrigin = (origin: string) => {
    const noPort = origin.replace(/:\d+$/, '');

    if (noPort.endsWith('127.0.0.1')) {
        return true;
    }

    if (noPort.endsWith('localhost')) {
        return true;
    }

    return false;
};

export const isAllowedOrigin = (origin: string) =>
    isTolokaOrigin(origin) || isVsCodeOrigin(origin) || isDevOrigin(origin) || isTbOrigin(origin);
